/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { EReplaySegmentStatusIcon } from '../../../replay/models';

@Component({
  selector: 'fm-replay-balloon-header',
  templateUrl: './replay-balloon-header.component.html',
  styleUrls: ['./replay-balloon-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReplayBalloonHeaderComponent {
  @Input()
  public titleText: string;

  @Input()
  statusIcon: EReplaySegmentStatusIcon;
}
